(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceFinancialReportController', AdvertisingSourceFinancialReportController);

    AdvertisingSourceFinancialReportController.$inject = ['$scope', '$state', 'AdvertisingSourceFinancialReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter', '$translate'];

    function AdvertisingSourceFinancialReportController ($scope, $state, AdvertisingSourceFinancialReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter, $translate) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportCleanForBarChart = [];
        vm.reportCleanForMultiBarChart = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        vm.mainColumn = 'advertisingSourceName';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };
        vm.diagram3 = {
                chart: {
                    type: 'multiBarHorizontalChart',
                    height: 300,
                    showXAxis: true,
                    showYAxis: true,
                    duration: 500,
                    margin : {
                        top: 0,
                        right: 60,
                        bottom: 20,
                        left: 120
                    },
                    showLegend: true,
                    showValues: true,
                    stacked: true,
                    showControls: true,
                    controlLabels: {
                        grouped: 'Отдельно',
                        stacked: 'Суммировать'
                    }
                }
        };
        vm.diagram4 = {
                chart: {
                    type: 'multiBarHorizontalChart',
                    height: 300,
                    showXAxis: true,
                    showYAxis: true,
                    duration: 500,
                    margin : {
                        top: 0,
                        right: 60,
                        bottom: 20,
                        left: 120
                    },
                    showLegend: true,
                    showValues: true,
                    stacked: false,
                    showControls: false
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            AdvertisingSourceFinancialReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'callTime';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'callTime';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        // Main columns list
        vm.columns = [
            'advertisingSourceName',
            'budget',
            'callsCount',
            'callPrice',
            'uniqueLeadCount',
            'contactPrice',
            'targetedCount',
            'targetedPrice',
            'productCount',
            'productPrice',
            'avgServiceQuality',
            'losses'
        ];
        // Paired columns
        vm.addcolumns = [];
        vm.addcolumns['losses'] = 'lossesPercent';
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'budget','callsCount',
            'callPrice','uniqueLeadCount',
            'contactPrice','targetedCount',
            'targetedPrice','productCount',
            'productPrice', 'avgServiceQuality',
            'lossesPercent'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'budget':1, 'productPrice':1,
                'targetedPrice':1, 'contactPrice':1,
                'callPrice':1, 'lossesPercent': 1};

        function getMinMax(min, max, rows) {
            var val = 0;
            var reportCleanForMultiBarChartSort = [];
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if(row[vm.mainIdColumn] == -1) continue;
                reportCleanForMultiBarChartSort.push(row);
                if(val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function(name){
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function(name) {
                    if(row[name] !== null) {
                        if(max[name] === null) max[name] = row[name];
                        if(min[name] === null) min[name] = row[name];
                        if(vm.inverseColumns[name] === 1) {
                            if(max[name] > row[name]) max[name] = row[name];
                            if(min[name] < row[name]) min[name] = row[name];
                        } else {
                            if(max[name] < row[name]) max[name] = row[name];
                            if(min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
            // % Потерь
            reportCleanForMultiBarChartSort.sort(
                    function (a, b) {
                        return a.lossesPercent - b.lossesPercent;
                    }
            );
            vm.reportCleanForBarChart = [];
            for(var i = 0 ; i < reportCleanForMultiBarChartSort.length ; i++ ) {
                var row = reportCleanForMultiBarChartSort[i];
                vm.reportCleanForBarChart.push({key: row[vm.mainColumn], values: [{x:row[vm.mainColumn],y:row['lossesPercent']}]});
            }
            // Цена звонка, ₽ / Цена контакта, ₽ / Цена продуктивн., ₽
            reportCleanForMultiBarChartSort.sort(
                    function (a, b) {
                        return (a.callPrice+a.contactPrice+a.productPrice)-(b.callPrice+b.contactPrice+b.productPrice);
                    }
            );
            vm.reportCleanForMultiBarChart = [];
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.callPrice'), values: []});
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.contactPrice'), values: []});
            vm.reportCleanForMultiBarChart.push({key: $translate.instant('telestatApp.reportsCommon.tablesHeaders.productPrice'), values: []});
            for(var i=0;i<reportCleanForMultiBarChartSort.length;i++) {
                var row = reportCleanForMultiBarChartSort[i];
                vm.reportCleanForMultiBarChart[0].values.push({x:row[vm.mainColumn],y:row['callPrice']});
                vm.reportCleanForMultiBarChart[1].values.push({x:row[vm.mainColumn],y:row['contactPrice']});
                vm.reportCleanForMultiBarChart[2].values.push({x:row[vm.mainColumn],y:row['productPrice']});
            }
        }
    }
})();
